import { Text } from '@mantine/core'

import { useCurrencyAmounts } from '@/hooks/business/useCurrencyAmounts'
import { CoinCategory } from '@/services/category'
import { formatMarketCap } from '@/utils/number/format'

export default function VolumeColumn({ category }: { category: CoinCategory }) {
  const {
    amounts: [{ formattedValue }],
  } = useCurrencyAmounts({
    amounts: [Number(category.volume_24h_native.amount)],
    valueFormatter: formatMarketCap,
    currencyFormatOptions: {},
  })

  return <Text variant="body1">{formattedValue}</Text>
}
